import { render } from "./TipButton.vue?vue&type=template&id=69b123c4&scoped=true"
import script from "./TipButton.vue?vue&type=script&lang=js"
export * from "./TipButton.vue?vue&type=script&lang=js"

import "./TipButton.vue?vue&type=style&index=0&id=69b123c4&scoped=true&lang=css"

import exportComponent from "/Users/tatana/Documents/Chext/dev/neatify_frnt-bck/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b123c4"]])

export default __exports__